// extracted by mini-css-extract-plugin
export default {"wrapper":"Ey-z","viewport":"Fy-z","container":"Gy-z","slide":"Hy-z"};